module.exports = __webpack_public_path__ + "static/img/Taj-Brailey.9b12377.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Taj-Brailey.jpg
// module id = Tf7V
// module chunks = 0